/**
 * Order status
 */
export enum OrdType {

    /** Active. */
    MARKET = 'MARKET',

    /** Cancel. */
    LIMIT = 'LIMIT',

    /** Pegged. */
    PEGGED = 'PEGGED',

    /** Canceled. */
    STOP = 'STOP',

    /** Filled. */
    STOP_LIMIT = 'STOP_LIMIT',

    /** Unknown. */
    UNKNOWN = 'UNKNOWN'
}

export const ORDER_TYPE_LABEL_DICT: Partial<Record<OrdType, string>> = {
    [OrdType.LIMIT]:      'enums.order-type.limit',
    [OrdType.MARKET]:     'enums.order-type.market',
    [OrdType.STOP]:       'enums.order-type.stop',
    [OrdType.STOP_LIMIT]: 'enums.order-type.stop_limit'
};
